import React from 'react';
import Popup from 'components/popups/popup';
import I18n from 'lib/i18n/i18n';
import UserActions from 'lib/userActions';

class PopupTooltipSuccessFee extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.logEvent(this.props.openEvent || 'fees_popup_presented');
    }

    componentWillUnmount() {
        this.logEvent(this.props.closeEvent || 'fees_popup_closed');
    }

    logEvent(event) {
        switch (this.props.page) {
            case 'support_negotiation':
                UserActions.supportNegotiation(this.props.page, I18n.getString('itemPage::supportNegotiation::version'), this.props.item_id, event);
                break;
            case 'pending_auction':
                UserActions.sya(event);
                break;
            case 'pending_sale':
                UserActions.pendingSale(event);
            case 'update_reserve_price':
                UserActions.updateReservePrice(event)
        }
    }

    title() {
        return I18n.getString('itemPage::popupSuccessFees::title');
    }

    content() {
        return (
          <div>
              <div dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::text1')}}/>
              <table>
                  <thead>
                  <tr>
                      <th dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::th1')}}/>
                      <th dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::th2')}}/>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr1td1')}}/>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr1td2')}}/>
                  </tr>
                  <tr>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr2td1')}}/>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr2td2')}}/>
                  </tr>
                  <tr>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr3td1')}}/>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr3td2')}}/>
                  </tr>
                  <tr>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr4td1')}}/>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr4td2')}}/>
                  </tr>
                  <tr>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr5td1')}}/>
                      <td dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFees::tr5td2')}}/>
                  </tr>
                  </tbody>
              </table>
              <p dangerouslySetInnerHTML={{__html:I18n.getString('itemPage::popupSuccessFeesTextUnderTable::p')}}/>
          </div>
        );
    }
}
PopupTooltipSuccessFee.defaultProps = {
    popupClassName: 'popup-tooltip popup-tooltip-success-fee popup-compact',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

export default PopupTooltipSuccessFee;